module.exports = __webpack_public_path__ + "ed0c741887006b68e20b0d4c5f41adf4.svg";